import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const DesktopPickerWrapper = styled.label`
  display: none;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;

  ${media.sm`
    display: initial;
  `}
`;

export const DesktopLabel = styled.div`
  font-size: 15px;
  margin-bottom: 3px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  text-align: left;
`;

export const DateRangePickerWrapper = styled.div`
  position: absolute;
  z-index: 999;
  margin-top: 20px;
`;

export const CalendarInfoWrapper = styled.div`
  display: flex;
  padding: 0 35px;
`;
